module.exports = __webpack_public_path__ + "static/assets/boce-status.ef16fd76.png";